if (!customElements.get("scroll-to-top")) {
  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.checkVisibleHandler = this.checkVisible.bind(this); // Lưu tham chiếu hàm bind
    }

    connectedCallback() {
      if (typeof window !== "undefined") {
        this.addEventListener("click", this.onClick);
        window.addEventListener("scroll", this.checkVisibleHandler);
      }
    }

    disconnectedCallback() {
      if (typeof window !== "undefined") {
        this.removeEventListener("click", this.onClick);
        window.removeEventListener("scroll", this.checkVisibleHandler);
      }
    }

    checkVisible() {
      window.requestAnimationFrame(() => {
        if (window.scrollY > this.pageHeight) {
          this.classList.add("scroll-to-top--visible");
        } else {
          this.classList.remove("scroll-to-top--visible");
        }
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }

  customElements.define("scroll-to-top", ScrollToTop);

}